import { useEffect, useState } from "react";
import { StringParam, useQueryParam } from "use-query-params";
import { useAxiosGet } from "../../axios";
import { searchCoupon } from "../../store/actions/coupon";

export const useUpdater = (dispatch: any) => {
  const [updaterRequestId] = useQueryParam("updater_id", StringParam);
  const [loading, setLoading] = useState(false);

  const loadUpdaterLead = async () => {
    setLoading(true);

    if (!updaterRequestId) {
      setLoading(false);
      return;
    }

    dispatch({
      type: "SET_UPDATER_REQUEST",
      payload: {
        loading: true,
        id: updaterRequestId,
        fetched: false,
        payload: null,
      }
    });

    const fetchUpdaterRequest = async () => {
      const response = await useAxiosGet(`/updater/request/${updaterRequestId}`);
      if (response?.data?.payload) {
        dispatch({
          type: "SET_UPDATER_REQUEST",
          payload: {
            loading: false,
            id: updaterRequestId,
            fetched: true,
            payload: response.data.payload,
          }
        });

        await dispatch(searchCoupon("UPDATER15"));
      } else {
        dispatch({
          type: "SET_UPDATER_REQUEST",
          payload: {
            loading: false,
            id: null,
            fetched: true,
            payload: null,
          }
        });
      }
    };

    await fetchUpdaterRequest();

    setLoading(false);
  };

  useEffect(() => {
    loadUpdaterLead();
  }, []);

  return {
    updaterRequestId,
    isUpdaterLoading: loading,
  };
};
